import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, TextField, Typography, Grid } from "@mui/material";

import Image from '../../../ui-components/Image';
import "../../../../assets/styles/audio-question.css";

export default function ListenAndAnswer({ question, onAnswer = () => {} }) {
	const theme = useTheme();
	const audioPlayerRef = React.useRef();
	const [playing, setPlaying] = React.useState(null);
	const [answer, setAnswer] = React.useState(
		Array(question.totalQuestions).fill("")
	);

	React.useEffect(() => {
		// reset proceed button
		setAnswer(Array(question.totalQuestions).fill(""));
	}, [question]);

	const handleSetAnswer = (i, ansText) => {
		let ans = [...answer];
		ans[i] = ansText.trim();
		setAnswer(ans);

		const canProceed =
			ans.filter((a) => a !== "").length === question.totalQuestions;

		onAnswer({
			canProceed,
			answer: ans,
		});
	};

	const playAudio = (index, audio) => {
		const audioSrc = audio;
		audioPlayerRef.current.src = audioSrc;
		audioPlayerRef.current.play();
	};

	return (
		<React.Fragment>
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionList.map((k, i) => (
					<Grid
						container
						sx={{ mt: 2 }}
						key={`audio-question-${i}-${Math.random()}`}
					>
						<Grid
							item
							sm={12}
							xs={12}
							className={
								"audio-question-container " +
								(i === playing ? "active" : "")
							}
							onClick={() => {
								setPlaying(i);
								playAudio(i, `https://s3.ap-southeast-2.amazonaws.com/static.lln.training/acsf3-short-quiz-resources/audio/${k.audio}`);
							}}
						>
							<Image
								src='clipart/audio.png'
								alt="audio"
								style={{ width: "3rem" }}
                                skeletonHeight="3rem"
                                skeletonWidth="3rem"

							/>{" "}
							<Typography
								sx={{
									color: theme.palette.primary.main,
									fontWeight: "bold",
								}}
							>
								{k.text}
							</Typography>
						</Grid>
						<Grid
							item
							sm={12}
							xs={12}
							className="audio-answer-container"
						>
							<Typography sx={{ width: "35%" }}>
								Word {i + 1}:
							</Typography>
							<TextField
								size="small"
                                defaultValue={answer[i] || ''}
								fullWidth
								onBlur={(e) =>
									handleSetAnswer(i, e.target.value)
								}
							/>
						</Grid>
					</Grid>
				))}
			</Box>

			<audio ref={audioPlayerRef} />
		</React.Fragment>
	);
}
